import PropTypes from "prop-types";
import classNames from "classnames";
import { useMemo } from "react";

const range = 100;
const ovalSize = (selfOrientation) => (selfOrientation - 50) / 100 * range * 2;

const EclipseChart = ({ percentile, target, values }) => {

	const blockerClassNames = useMemo(() => classNames(
		'on-top',
		{
			'bg-danger': percentile && percentile < 40,
			'bg-green': percentile && percentile >= 60,
			'bg-orange': percentile && percentile >= 40 && percentile < 60
		}
	), [percentile]);

	return (
		<div className="eclipse-chart">
			{target ? <div className="target">{target}</div> : null}
			<div
				className={`blocker ${values[0].value > values[1].value ? blockerClassNames : ""}`}
				style={{
					transform: `scale(${(100 + ovalSize(values[0].value)) / 100})`
				}}
			>
				<div className="blocker-inner">
					{values[0].label}<br />
					<span>({values[0].value?.toFixed(2)}%)</span>
				</div>
			</div>
			<div
				className={`eclipse ${values[1].value > values[0].value ? blockerClassNames : ""}`}
				style={{
					transform: `scale(${(100 - ovalSize(values[0].value)) / 100})`
				}}
			>
				<div
					className="eclipse-inner"
				>
					{values[1].label}<br />
					<span>({values[1].value?.toFixed(2)}%)</span>
				</div>
			</div>
		</div>
	);
};

EclipseChart.propTypes = {
	percentile: PropTypes.number,
	target: PropTypes.string,
	values: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string.isRequired,
		value: PropTypes.number.isRequired
	})).isRequired
};

EclipseChart.defaultProps = {
	percentile: null,
	target: null
}

export default EclipseChart;
